export const DEALER_TYPE_ABBR_AD = 'a';
export const DEALER_TYPE_ABBR_PI = 'p';
